import { render } from "./NewKeyResultList.vue?vue&type=template&id=af2488a6&scoped=true"
import script from "./NewKeyResultList.vue?vue&type=script&lang=js"
export * from "./NewKeyResultList.vue?vue&type=script&lang=js"

import "./NewKeyResultList.vue?vue&type=style&index=0&id=af2488a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af2488a6"

export default script